var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.tips),function(item){return _c('transition',{key:item.index,attrs:{"name":"slide-fade"}},[(item.isShow)?_c('div',{staticClass:"tip"},[_c('div',{staticClass:"cont"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.data.title))])])]):_vm._e()])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }